import { api } from "@/api/client";

export type VersionInformation = {
  waypointVersion: string;
  waypointBuildDate: string;

  coordinatorVersion: string;
  coordinatorMinVersion: string;
  coordinatorVersionOK: boolean;

  qualifierVersion: string;
  qualifierMinVersion: string;
  qualifierVersionOK: boolean;
};

export function getVersionInfo() {
  return api.get<VersionInformation>("version");
}
